export const api_key = "CNCPWtto1Ykw5lMwOqIs";
export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://retail-api-uat-one-sdk-wrapper-app.carenow.healthcare");
export const sdkURL = (url = "") =>
  new URL(url, "https://sdk-one-uat.carenow.healthcare");
